import { givenName, type AssistantMeDTO } from '@contracts/assistant';
import type { Principal } from '@contracts/common';

/** How the person asked to be called (D124: `givenName` is the prompt's too, so both sides say the same). */
export function addressOf(p: Pick<AssistantMeDTO, 'addressAs' | 'addressCustom'>, name: string): string {
  switch (p.addressAs) {
    case 'anh': return `anh ${givenName(name)}`;
    case 'chi': return `chị ${givenName(name)}`;
    case 'custom': return p.addressCustom ?? givenName(name);
    case 'name': return givenName(name);
  }
}

/** The empty conversation's first line, in the persona's own name and self-name (D124). */
export const greetingOf = (prefs: AssistantMeDTO, principal: Principal): string =>
  `Chào ${addressOf(prefs, principal.name)}, ${prefs.selfName} là ${prefs.personaName}. Hôm nay ${prefs.selfName} giúp gì được ạ?`;
